/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { Button, Stack, Typography } from '@worthy-npm/worthy-common-ui-components';
import GA from '../../data/GA';
import { StepProps } from '../steps/common';
import { Step, StepContainer } from '../../styles/common';
import StepTitle from '../stepTitle';
import { Lines, Star, TextBoxWrapper, TypeWrapper } from '../../styles/submitType.styles';

function StepSelectSubmitType({ title, stepCaption, props, next, exit, active }: StepProps) {
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!active) return;
    GA.flowTypeView();
  }, [active]);

  return (
    <StepContainer
      data-automation="type-select-step"
      data-testid="type-select-step"
      style={{ height: '100%', overflow: 'auto' }}
    >
      <Step>
        <StepTitle
          prev={false}
          stepCaption={stepCaption}
          stepTitle={title || 'What type of jewelry do you have?'}
          stepNotice=""
          optionalProps={props || {}}
        />
        <Stack
          direction="row"
          gap={{ xs: 1, sm: 2 }}
          flexWrap="wrap"
          justifyContent="center"
          sx={{ mt: 4, mb: 4 }}
        >
          <TypeWrapper>
            <Lines />
            <TextBoxWrapper>
              <Typography variant="h4" noWrap>
                Quick Online Form
              </Typography>
              <Typography variant="body1" color="black">
                Just answer a few simple questions about your piece.
              </Typography>
            </TextBoxWrapper>
            <Button
              disableElevation
              fullWidth
              type="submit"
              data-automation="manually"
              variant="contained"
              size="large"
              color="highlight"
              onClick={(e) => {
                if (busy) return;
                setBusy(true);
                setTimeout(() => {
                  GA.onFlowTypeClick('submitByForm');
                  next(e);
                  setTimeout(() => {
                    setBusy(false);
                  }, 150);
                }, 150);
              }}
            >
              Continue with Form
            </Button>
          </TypeWrapper>
          <TypeWrapper>
            <Star />
            <TextBoxWrapper>
              <Typography variant="h4" noWrap>
                Worthy AI Assistant
              </Typography>
              <Typography variant="body1" color="black">
                Let AI do the work – just describe your item in your own words.
              </Typography>
            </TextBoxWrapper>
            <Button
              disableElevation
              fullWidth
              type="submit"
              data-automation="ai"
              variant="contained"
              size="large"
              color="highlight"
              onClick={(e) => {
                if (busy) return;
                setBusy(true);
                setTimeout(() => {
                  GA.onFlowTypeClick('submitByAi');
                  if (exit) exit('chat');
                  setTimeout(() => {
                    setBusy(false);
                  }, 150);
                }, 150);
              }}
            >
              Continue with AI
            </Button>
          </TypeWrapper>
        </Stack>
        <Typography variant="body1" color="black" textAlign="center">
          You can always change your method later.
        </Typography>
      </Step>
    </StepContainer>
  );
}

export default StepSelectSubmitType;
